import React, { useEffect } from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { PageContainer } from 'src/common';
import { useAuth } from 'src/state/auth';
import { useNavigate } from 'react-router-dom';
import V1 from './V1/V1';
import V2 from './V2/V2';

const Div = styled(PageContainer)`
  .panel {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    grid-gap: 10px;
  }
`;

const InsightsPage = () => {
  const { features } = useAuth();
  const navigate = useNavigate();
  useGaEventPageView('Cydea | Insights');

  useEffect(() => {
    if (!features['app.insights']) {
      navigate('/');
    }
  }, [features['app.insights'], navigate]);

  return (
    <>
      <Meta title={`Cydea | Insights`} feedbackScript />
      <Div>{features['app.insights-v2'] ? <V2 /> : <V1 />}</Div>
    </>
  );
};

export default InsightsPage;
